export default "__VITE_ASSET__CEiPGOGu__"